import { Component, Input, type OnInit } from '@angular/core'
import { FormControl } from '@angular/forms'
import { ReviewCategoryRatingForAI, getAIReviewCategoriesAvgRating } from '@tokeet-frontend/reviews'
import { Store } from '@ngrx/store'
import { AutomationHandler, selectAutomationGroupsByHandler } from '@tokeet-frontend/automations'
import { Destroyable, isSomething, selectSome, untilDestroy } from '@tokeet-frontend/tv3-platform'
import { filter, map, tap } from 'rxjs/operators'

@Component({
  selector: 'app-booking-rating',
  templateUrl: './booking-rating.component.html',
  styleUrls: ['./booking-rating.component.scss'],
})
export class BookingRatingComponent extends Destroyable implements OnInit {
  _ratings: ReviewCategoryRatingForAI[]
  @Input() set rating(ratings: ReviewCategoryRatingForAI[]) {
    this._ratings = ratings
    this.ratingCtrl.setValue(getAIReviewCategoriesAvgRating(ratings))
  }

  ratingCtrl = new FormControl(0)

  isAutomationRating = false
  automationRating = 5

  constructor(private store: Store<any>) {
    super()
  }

  ngOnInit(): void {
    this.store
      .pipe(
        selectSome(selectAutomationGroupsByHandler(AutomationHandler.SendReview)),
        map((automations) => automations[0]),
        tap((automation) => {
          this.automationRating = automation.settings?.reviews?.default || 5
        }),
        filter(() => !isSomething(this._ratings)),
        untilDestroy(this)
      )
      .subscribe((automation) => {
        this.isAutomationRating = true
        this.ratingCtrl.setValue(this.automationRating)
      })
  }
}
